export default "__VITE_ASSET__CDpbILEI__"